<template>
    <section class="restaurant-details-block">
        <h2 v-test:title>{{ title }}</h2>

        <slot />
    </section>
</template>

<script>
    export default {
        name: 'restaurant-details-block',

        props: {
            title: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    h2 {
        color: $primary;
        font-size: rem(24px);
        font-weight: bold;
    }
</style>
